import { gql } from 'graphql-request';

export const getCustomerOrderIdQuery = async (): Promise<string> => {
  const response = await fetch('/schemas/customerOrderById.txt');
  const text = await response.text();

  const query = gql`
    ${text}
  `;

  return query;
};
